import React from 'react';

const ModalFourContent = () => {
	return (
		<div className='slideshow'>
			<figure className='slide-show-project-modal'>
				{/* Project Details Starts */}
				<figcaption>
					<h3>Web App Project</h3>
					<div className='row open-sans-font'>
						<div className='col-12 col-sm-6 mb-2'>
							<i className='fa fa-file-text-o pr-2'></i>
							<span className='project-label'>Project </span>:{' '}
							<span className='ft-wt-600 uppercase'>Web App</span>
						</div>
						{/* End .col */}

						<div className='col-12 col-sm-6 mb-2'>
							<i className='fa fa-user-o pr-2'></i>
							<span className='project-label'>Role </span>:{' '}
							<span className='ft-wt-600 uppercase'>Web Developer</span>
						</div>
						{/* End .col */}

						<div className='col-12 col-sm-6 mb-2'>
							<i className='fa fa-code pr-2'></i>
							<span className='project-label'>Languages </span>:{' '}
							<span className='ft-wt-600 uppercase'>
								VueJS, JavaScript, Bootstrap, Firebase
							</span>
						</div>
						{/* End .col */}

						<div className='col-12 col-sm-6 mb-2'>
							<i className='fa fa-external-link pr-2'></i>
							<span className='ft-wt-600 uppercase'>
								<a
									href='https://fix-it-app.netlify.app/'
									target='_blank'
									rel='noreferrer'
								>
									Preview Site
								</a>
							</span>
						</div>
						{/* End .col */}
					</div>
					{/* End .row */}
				</figcaption>
				{/* Project Details Ends */}

				{/*  Main Project Content Starts */}
				<img className='mb-3' src='img/projects/fixit.png' alt='Portolio' />
				<img className='mb-3' src='img/projects/fixit2.png' alt='Portolio' />
				{/* Main Project Content Ends */}
			</figure>
		</div>
		//  End .slideshow
	);
};

export default ModalFourContent;
